'use client'

import React from 'react'
import { cn } from '@/lib/utils'

type Props = {
  onResend: () => void
  cooldown: number
  loading?: boolean
  className?: string
}

/** "Resend code" text link that counts down while a resend is on cooldown. */
const ResendCodeLink = ({ onResend, cooldown, loading, className }: Props) => {
  const disabled = loading || cooldown > 0
  return (
    <button
      type="button"
      onClick={onResend}
      disabled={disabled}
      aria-live="polite"
      className={cn(
        'w-fit rounded-[6px] text-[13px] font-medium leading-none tracking-[-0.2px] text-brand outline-none',
        'transition-colors duration-[140ms] hover:text-brand-2 focus-visible:ring-2 focus-visible:ring-brand/40',
        'disabled:cursor-not-allowed disabled:text-ink-4 disabled:hover:text-ink-4',
        className
      )}
    >
      {loading ? (
        'Resending…'
      ) : cooldown > 0 ? (
        <>
          Resend code in <span className="tabular-nums">{cooldown}s</span>
        </>
      ) : (
        'Resend code'
      )}
    </button>
  )
}

export default ResendCodeLink
